import React from "react";
import { Box, Typography, Card, CardContent, CircularProgress, useTheme } from "@mui/material";
import { tokens } from "../../theme";

export default function StatCard({ title, value, icon, color, subtitle, loading }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Card
      sx={{
        background: `linear-gradient(135deg, ${colors.primary[400]} 0%, ${colors.primary[500]} 100%)`,
        border: `1px solid ${colors.grey[800]}30`,
        borderRadius: "16px",
        p: 2,
        height: "100%",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: `0 8px 24px rgba(0, 0, 0, 0.2)`,
        },
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography
              variant="h6"
              sx={{
                color: colors.grey[400],
                mb: 1,
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: colors.grey[100],
                fontWeight: 700,
                mb: 0.5,
              }}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: colors.greenAccent[500] }} />
              ) : (
                value?.toLocaleString() || 0
              )}
            </Typography>
            {subtitle && (
              <Typography
                variant="caption"
                sx={{
                  color: colors.grey[500],
                  fontSize: "0.75rem",
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "12px",
              background: `linear-gradient(135deg, ${color}40 0%, ${color}60 100%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: `1px solid ${color}60`,
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}








